$.fn.findAndSelf = function (filter) {
  let elements = this.find(filter).get()
  if (this.is(filter)) {
    elements = [...this.get(), ...elements]
  }

  return $(elements)
}
